import { ImageUrlTransformationBuilder } from './image-url-transformation-builder';
export function transformImageUrl(url) {
    return new ImageUrlTransformationBuilder(url);
}
//# sourceMappingURL=image-url-transformation-builder.factory.js.map